import { I, N, writeSkyVector } from './model'
import type { SkyState } from './types'

/** Shared CSS/WebGL stop positions. The first GL draw is exactly this gradient (one-LSB dither aside). */
export function skyBootPaint(state: SkyState): string {
  const v = new Float32Array(N)
  writeSkyVector(state, v)
  const rgb = (i: number) => `rgb(${Math.round(v[i] * 255)} ${Math.round(v[i + 1] * 255)} ${Math.round(v[i + 2] * 255)})`
  return `linear-gradient(180deg, ${rgb(I.top)} 0%, ${rgb(I.middle)} 55%, ${rgb(I.bottom)} 100%)`
}

/** Paint a persistent host behind the canvas before loading this lazy renderer. */
export function applySkyBootPaint(element: HTMLElement, state: SkyState): void {
  element.style.backgroundImage = skyBootPaint(state)
  element.style.backgroundColor = '#071321'
}
